import { Switch } from 'antd';
import cx from 'classnames';

import styles from './header-footer-landing-page.module.scss';
import {
  BtnLevel,
  BtnSize,
  Button,
  IconEnum,
} from '@greenkub-fronts/shared/ui';
import { ArraySignatures, Project } from '@greenkub-fronts/shared/interface';

import { TemplateEnum } from '../../../utils/enum';
import dayjs from 'dayjs';

export interface HeaderFooterLandingPageProps {
  headerFocus: boolean;
  isSignature: boolean;
  signatures: ArraySignatures;
  allSignatureDone: boolean;
  onCustomerSignHandler: () => void;
  goToSign: () => void;
  documentSlug: TemplateEnum | undefined;
  checkBoxPendingSign: boolean;
  askForSignHandler: (documentSlug: TemplateEnum) => void;
  project: Project | null;
  copyQuoteLink: () => void;
  copySignLink: () => void;
  sendEmail: () => void;
  navigate: (url: string) => void;
  createTaskTrigger: () => void;
  isBDC: boolean;
  signedAt?: string | null;
}

// Bannière pour signer ou partager le lien
const HeaderFooterLandingPage = (props: HeaderFooterLandingPageProps) => {
  const {
    headerFocus,
    isSignature,
    signatures,
    allSignatureDone,
    onCustomerSignHandler,
    goToSign,
    documentSlug,
    checkBoxPendingSign,
    askForSignHandler,
    project,
    copyQuoteLink,
    copySignLink,
    sendEmail,
    navigate,
    createTaskTrigger,
    isBDC,
    signedAt,
  } = props;

  if (signedAt) {
    return (
      <div className={styles['LandingPage-header-container-header']}>
        <b>Ce document a été signé le {dayjs(signedAt).format('DD/MM/YYYY')}</b>
      </div>
    );
  }

  return (
    <div
      className={cx(
        styles['LandingPage-header-container'],
        isSignature && styles['isSignature'],
        headerFocus && styles['headerFocus']
      )}
    >
      <div className={styles['LandingPage-header-container-header']}>
        {isSignature ? (
          <>
            <p>
              {'Veuillez reviser le document et le signer' +
                (signatures?.length > 1
                  ? ' aux ' + signatures?.length + ' endroits obligatoires'
                  : '')}
            </p>
            {allSignatureDone ? (
              <Button
                level={BtnLevel.SECONDARY}
                onClick={() => onCustomerSignHandler()}
                label="Signer"
              />
            ) : (
              <Button
                level={BtnLevel.SECONDARY}
                onClick={() => goToSign()}
                label={signatures[0] !== true ? 'Commencer' : 'Continuer'}
              />
            )}
          </>
        ) : (
          <>
            {documentSlug &&
              [
                TemplateEnum.MANDAT_GESTION,
                TemplateEnum.DECHARGE_NON_CONFORMITE,
                TemplateEnum.DECHARGE_TVX_SANS_DECLARATION,
                TemplateEnum.DECHARGE_CLIENT,
              ].includes(documentSlug as TemplateEnum) && (
                <>
                  <p>Positionner comme "à signer" sur l'espace client :</p>
                  <Switch
                    checked={checkBoxPendingSign}
                    onChange={() =>
                      askForSignHandler(documentSlug as TemplateEnum)
                    }
                  />
                </>
              )}
            {documentSlug && documentSlug === TemplateEnum.BDC && (
              <Button
                label="Retour R1"
                onClick={() => navigate(`/r1/${project?.id}/15/`)}
                size={BtnSize.SMALL}
                level={BtnLevel.TERTIARY}
              />
            )}
            {documentSlug && documentSlug === TemplateEnum.BDC && (
              <Button
                IconeLeft={IconEnum.FILE_COPY}
                label="Lien du devis"
                size={BtnSize.SMALL}
                onClick={() => {
                  copyQuoteLink();
                  if (isBDC) {
                    createTaskTrigger();
                  }
                }}
                level={BtnLevel.SECONDARY}
              />
            )}

            <Button
              IconeLeft={IconEnum.FILE_COPY}
              label="Lien de la signature"
              onClick={() => {
                copySignLink();
                if (isBDC) {
                  createTaskTrigger();
                }
              }}
              size={BtnSize.SMALL}
              level={BtnLevel.SECONDARY}
            />

            <Button
              label="Envoyer par mail"
              IconeLeft={IconEnum.MAIL}
              level={BtnLevel.INACTIF}
              onClick={() => sendEmail()}
              size={BtnSize.SMALL}
            />

            {documentSlug && documentSlug === TemplateEnum.BDC && (
              <Button
                label="Préparation WC"
                onClick={() =>
                  navigate(`/task/${project?.id}/preparation-welcome-call`)
                }
                size={BtnSize.SMALL}
                level={BtnLevel.TERTIARY}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderFooterLandingPage;
